export default __webpack_public_path__ + "static/media/Haren Textiles Private Limited.363def91.jpg";